import color from "@definitions/mui/color";
import { fontFamSecondary } from "@definitions/mui/custom";
import { makeStyles } from "@mui/styles";

interface IProps {
  borderTopCurved?: boolean;
  size?: string;
  textEllipsis?: any;
}

const useStyles = ({ borderTopCurved, size, textEllipsis }: IProps) => {
  return makeStyles(() => ({
    helpSlider: {
      backgroundImage:
        "linear-gradient(0deg, rgba(46, 67, 77, 0.5), rgba(46, 67, 77, 0.5)), url(https://storage-assurance-dev.mytens.id/assets/mytenscustomer/img_helpdesk_center.jpg)",
      backgroundPosition: "center",
      backgroundSize: "cover",
      position: "fixed",
      left: 0,
      top: 0,
      zIndex: 0,
    },
    helpDetailSlider: {
      ".slick-dots": {
        bottom: "-32px",
        "& > li": {
          "& > button": {
            "&:before": {
              color: "transparent !important",
              backgroundColor: "#FDFDFD",
            },
          },
          "&.slick-active": {
            "& > button": {
              "&:before": {
                backgroundColor: `${color.white} !important`,
              },
            },
          },
        },
      },
    },
    helpWrapperItem: {
      borderTopLeftRadius: borderTopCurved ? "8px" : 0,
      borderTopRightRadius: borderTopCurved ? "8px" : 0,
      position: "relative",
      zIndex: 1,
      "& > div": {
        "& + div": {
          marginTop: "32px",
        },
      },
    },
    helpSliderContent: {
      "& > *": {
        color: color.white,
      },
    },
    topicItem: {
      height: "54px",
      border: `1px solid ${color.grey.light}`,
      borderRadius: "5px",
      cursor: "pointer",
    },
    svgSize: {
      "& svg": {
        width:
          size === "xs"
            ? "12px"
            : size === "sm"
            ? "28px"
            : size === "md"
            ? "40px"
            : size === "lg"
            ? "64px"
            : "104px",
        height:
          size === "xs"
            ? "12px"
            : size === "sm"
            ? "28px"
            : size === "md"
            ? "40px"
            : size === "lg"
            ? "64px"
            : "104px",
      },
    },
    customDotSlider: {
      "& .slick-dots": {
        bottom: -36,
        "& li": {
          margin: "0 6px",
          "& button": {
            color: "transparent",
            "&:before": {
              width: "24px !important",
              height: "6px !important",
              color: "transparent !important",
              backgroundColor: "#FDFDFD",
              borderRadius: 5,
              opacity: 0.3,
              transition: "opacity 500ms linear",
            },
          },
          "&.slick-active": {
            "& button": {
              "&:before": {
                backgroundColor: "#FDFDFD !important",
                opacity: 1,
              },
            },
          },
        },
      },
    },
    customSearchBox: {
      "& > div": {
        fontSize: 14,
        fontFamily: fontFamSecondary,
        maxWidth: 432,
        height: 48,
        backgroundColor: "#FDFDFD",
        border: "1px solid #DEE3ED",
      },
    },
    videoDescription: {
      fontSize: "16px",
      lineHeight: "21px",
      fontFamily: fontFamSecondary,
      color: color.inactive.secondary,
      display: "-webkit-box",
      WebkitLineClamp: textEllipsis ? 99 : 3,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "& > p": {
        margin: 0,
        "& + p": {
          marginTop: "16px",
        },
      },
    },
    buttonStyle: {
      padding: 12,
      fontSize: 16,
      fontWeight: 700,
      width: "100%",
      backgroundColor: "transparent",
      color: color.primary.main,
      border: `1px solid ${color.primary.main}`,
      boxShadow: "none",
      lineHeight: "24px",
      fontFamily: fontFamSecondary,
    },
    tab: {
      "& .MuiTabs-root": {
        minHeight: 0,
        "& .MuiTabs-flexContainer": {
          "& button": {
            paddingTop: 0,
            paddingBottom: 10,
            width: "50%",
            minHeight: 0,
            "& span": {
              fontWeight: "400",
              color: color.inactive.secondary,
              lineHeight: "19px",
            },
            "&.Mui-selected": {
              padding: "0 16px 10px 16px",
              "& span": {
                fontWeight: "600",
                color: color.primary.main,
              },
            },
          },
          "& + .MuiTabs-indicator": {
            margin: "0 16px",
            width: "calc(50% - 32px) !important",
            backgroundColor: "#E08D99",
            borderRadius: 4,
          },
        },
      },
    },
    filter: {
      "& > button": {
        padding: 12,
        fontSize: 14,
        height: "32px",
        minWidth: 0,
        "& + button": {
          marginLeft: "8px",
        },
        "& svg": { width: 16, height: 16 },
      },
    },
  }))();
};

export default useStyles;
